exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bn-input-label[data-v-67b6d724]{font-size:17px;color:#979797}.flex-class[data-v-67b6d724]{margin-top:10px}", ""]);

// exports
